<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item v-if="user && [1, 2, 5].includes(user.user_group_id)" class="startBtn">
          <el-button type="primary" @click="add" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="button" slot-scope="params">
        <el-button class="dispatchbtn" type="primary" @click="dispatch(params.params)" size="mini">派单</el-button>
      </template>
    </Table>

    <ContractDispatch ref="dispatch" @onDispatched="getList" />
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'contract',
      formInline: {
        isstatus: 1,
      },
      formCtrl: [
        {
          label: "合同编号",
          keyName: "con_num",
          placeholder: "请填写合同编号",
          type: "text",
        },
        {
          label: "客户名称",
          keyName: "shname",
          placeholder: "请填写客户名称",
          type: "text",
        },
      ],
      cols: [
        { keyName: "con_num", label: "合同编号", minwidth: 120 },
        { keyName: "shname", label: "客户名称", minwidth: 150 },
        { keyName: "name", label: "货物名称", minwidth: 120 },
        { keyName: "pricing", label: "计价方式", minwidth: 120 },
        { keyName: "cprice", label: "公司单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dprice", label: "司机单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "ton", label: "合同量", align: 'right', className: 'pr30', minwidth: 120 },
        // { keyName: "caton", label: "计算量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "starttime", label: "开始日期", minwidth: 120 },
        { keyName: "endtime", label: "结束日期", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { keyName: "", label: "派单", slot: 'button', minwidth: 120 },
      ],
      btns: [
        {
          icon: 'el-icon-paperclip',
          class: 'fjbtn',
          title: '附件',
          cb: ({ id }) => {
            this.$router.push(
              `/contract/file?id=${id}&mode=edit`
            );
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/contract/detail?id=${id}&mode=edit`
            );
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      baseParams: ['isstatus'],
    };
  },
  methods: {
    dispatch({ id }) {
      // console.log(id)
      // this.mform.contractid = id
      // this.showDialog()
      // console.log(this.$refs.dispatch)
      this.$router.push(
        `/contract/addorder?contractid=${id}`
      );
      // const dispatch = this.$refs.dispatch
      // if (dispatch && dispatch.show) {
      //   dispatch.mform.contractid = id
      //   dispatch.show()
      // }
    },
    add() {
      this.$router.push(
        `/contract/detail?mode=add`
      );
    },
  },
  mounted() {
    this.getList()
    const { user_group_id } = this.user
    if ([2, 3, 4].includes(user_group_id)) {
      // 会计去掉派单列
      this.cols.splice(this.cols.length - 1, 1)
    }
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-table .pr30 .cell {
  padding-right: 30px;
}
</style>
